<template>
  <el-menu-item v-if="item.leaf" :index="item.id" class="report-sub-item-leaf" @click="onClick(item)">
    <template slot="title">
      <span class="el-icon-tickets">&nbsp;{{ getNameByLanguage(item) }}</span>
    </template>
  </el-menu-item>
  <el-submenu v-else :index="item.id" :class="'report-sub-item report-sub-item-'+level">
    <template slot="title">
      <span class="el-icon-folder" :style="{paddingLeft:level===2?'40px':'',color:level===1?'#000000':'#666666'}">&nbsp;{{ getNameByLanguage(item) }}</span>
    </template>
    <template v-for="report in item.exploreList">
      <report-sub-item :key="report.id" :item="report" :level="level+1" @click="onClick" />
    </template>
  </el-submenu>
</template>

<script>
export default {
  name: 'ReportSubItem',
  props: {
    item: { type: Object, default: () => null },
    level: { type: Number, default: 1 }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  methods: {
    onClick(data) {
      this.$emit('click', data)
    },
    // 根据中英文获取名称
    getNameByLanguage(data) {
      return this.isZh ? data.name : (data.englishName || data.name)
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  .report-sub-item::v-deep.el-submenu {
    .el-submenu__title {
      font-weight: bold;
    }
  }
  .report-sub-item-2::v-deep.el-submenu {
    &.is-opened {
      .el-submenu__title {
        .el-submenu__icon-arrow.el-icon-arrow-down {
          -webkit-transform: unset;
          transform: unset;
        }
      }
    }
    .el-submenu__title {
      .el-submenu__icon-arrow.el-icon-arrow-down {
        -webkit-transform: rotateZ(270deg);
        transform: rotateZ(270deg);
      }
    }
  }
  .report-sub-item-leaf::v-deep .el-icon-tickets {
    font-size: 12px;
    color: #000000;
  }
  .report-sub-item::v-deep .el-icon-folder {
    font-size: 12px;
    font-weight: 700;
  }
}
</style>
